import * as React from 'react';
/**
 *
 * Original name: shield
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A367
 *
 */
export const ShieldPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m25.414 28.586-2.828 2.828L31 39.828l12.414-12.414-2.828-2.828L31 34.172l-5.586-5.586Z", fill: "currentColor" }),
    React.createElement("path", { d: "M32 7.74 11 18.793v8.622a28.32 28.32 0 0 0 13.263 24.064L32 56.365l7.737-4.887A28.317 28.317 0 0 0 53 27.415v-8.622L32 7.74Zm17 19.675A24.337 24.337 0 0 1 37.6 48.1L32 51.635 26.4 48.1A24.34 24.34 0 0 1 15 27.415v-6.208l17-8.947 17 8.947v6.208Z", fill: "currentColor" })));
